import styled, { css, keyframes } from 'styled-components';
import { Link } from '@amzn/storm-ui';
import { inkwell } from 'src/colors';

export const NavWrapper = styled.div`
  position: fixed;
  bottom: 0;
  z-index: 300;
`;

export const NavLink = styled(Link)`
  &&& {
    color: ${({ theme }) => theme.nav.link.color};
    text-decoration: ${({ theme }) => theme.nav.link.textDecoration};
  }

  &&&:hover {
    color: ${({ theme }) => theme.nav.link.color};
    text-decoration: ${({ theme }) => theme.nav.link.textDecoration};
    background-color: rgba(35, 47, 63, 0.05);
  }

  &&&:active {
    color: ${({ theme }) => theme.nav.link.color};
    text-decoration: ${({ theme }) => theme.nav.link.textDecoration};
    background-color: rgba(35, 47, 63, 0.1);
  }
`;

export const LinkButton = styled(Link)`
  &&& {
    color: ${({ theme }) => theme.nav.text.color};
    text-decoration: ${({ theme }) => theme.nav.link.textDecoration};
  }
`;

export const focusNavElementMixin = css`
  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgb(242 244 246);
  }
`;

const fadeIn = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 10%;
  }
`;

export const Overlay = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 60px;
  right: 0;
  bottom: 0;
  background-color: ${inkwell};
  z-index: 51;
  opacity: 10%;
  animation: ${fadeIn} 0.25s ease-out 0;
`;
